import React from 'react';
import { createPortal } from 'react-dom';

/** Brief intro text rendered inside the DialogueTextBox — shows the AI-generated whatTheyDo summary */
export const CompanyProfileStep: React.FC<{ whatTheyDo?: string }> = ({ whatTheyDo }) => {
  return (
    <div>
      <h3 className="text-sm font-semibold uppercase tracking-wide text-amber-600 dark:text-amber-400 mb-2">
        Company Profile
      </h3>
      <p className="text-base text-gray-700 dark:text-gray-300 leading-relaxed">
        {whatTheyDo || "Here's a quick overview of this business — what they do, how they make money, and the key forces working for and against them."}
      </p>
    </div>
  );
};

interface CompanyDescriptionOverlayProps {
  logoUrl?: string;
}

/** Company logo overlay rendered above the dialogue box with dark backdrop */
export const CompanyDescriptionOverlay: React.FC<CompanyDescriptionOverlayProps> = ({
  logoUrl,
}) => {
  if (!logoUrl) return null;

  return createPortal(
    <div className="fixed inset-0 z-[2147483000] pointer-events-none">
      {/* Dark backdrop */}
      <div className="absolute inset-0 bg-black/60" />
      {/* Positioned above the dialogue box — leave space for avatar + dialogue at bottom */}
      <div className="absolute top-0 left-0 right-0 bottom-[30vh] flex items-center justify-center p-4">
        <div className="relative lg:max-w-[675px] w-[92vw] max-h-full overflow-y-auto mx-auto pointer-events-auto">
          <div className="bg-white dark:bg-gray-800 rounded-xl shadow-2xl p-6 flex items-center justify-center">
            <img
              src={logoUrl}
              alt="Company logo"
              className="max-w-[200px] max-h-[200px] object-contain"
            />
          </div>
        </div>
      </div>
    </div>,
    document.body
  );
};
